module.exports = __webpack_public_path__ + "img/iconHistoryFace.166a09eb.svg";